"use strict";

/**
 *  平台设置
 *  @module 场景属性
 */

import Vue from "@/main";

// 默认数据
const form = {
  starrySkyBackgroundShow: true, //星空背景
  sunShadowShow: false, //日照阴影
  DayAndNightShadowsShow: false, //昼夜阴影
  atmosphericRenderingShow: true, //大气渲染
  AOShow: false, //AO效果
};

// 保存提交 (存储至localStorage)
const saveSceneSettings = (data) => {
  localStorage.setItem("sceneSettings", JSON.stringify(data));
};

// 对外暴露基本属性 / 取消保存
const exposureSceneSettings = () => {
  if (localStorage.getItem("sceneSettings")) {
    return JSON.parse(localStorage.getItem("sceneSettings"));
  } else {
    localStorage.setItem("sceneSettings", JSON.stringify(form));
    return JSON.parse(JSON.stringify(form));
  }
};

// 处理效果
const setSceneEffect = (data, map = Vue.$GLOBAL.map) => {
  const {
    starrySkyBackgroundShow,
    sunShadowShow,
    atmosphericRenderingShow,
    DayAndNightShadowsShow,
    AOShow,
  } = data;
  // 星空背景
  map.setSceneOptions({
    showSkyBox: starrySkyBackgroundShow,
    highDynamicRange: true,
  });
  // 日照阴影
  map.setSceneOptions({
    shadows: sunShadowShow,
    highDynamicRange: true,
  });
  // 大气渲染
  map.scene.showSkyAtmosphere = atmosphericRenderingShow;
  map.scene.skyAtmosphere.show = atmosphericRenderingShow;
  map.scene.globe.showGroundAtmosphere = atmosphericRenderingShow;
  // 昼夜阴影
  map.scene.globe.enableLighting = DayAndNightShadowsShow;
  // AO效果
  map.scene.postProcessStages.ambientOcclusion.enabled = AOShow;
};

export { saveSceneSettings, exposureSceneSettings, setSceneEffect };
